import { FarmRunnerService } from '@/services/retailer/FarmRunnerService'

export const namespaced = true

export const state = {
  leaderboard: []
}

export const mutations = {
  SET_LEADERBOARD(state, leaderboard) {
    state.leaderboard = leaderboard
  }
}

export const actions = {
  getLeaderboard({ commit }) {
    return new Promise(resolve => {
      let farmRunnerService = new FarmRunnerService()
      farmRunnerService.getLeaderboard().then(response => {
        commit('SET_LEADERBOARD', response.data)
        resolve(response.data)
      })
    })
  }
}
